import React from 'react'

type NameCellProps = {
  name?: string
  meta: string
}

const NameCell = ({ name, meta }: NameCellProps) => {
  return (
    <div>
      {name !== undefined && (
        <>
          <strong>{name}</strong> <br />
        </>
      )}
      {meta}
    </div>
  )
}

export default NameCell
